import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';
import Screen from '../../../../shared/utils/screen';

const SearchContainer = styled.div<React.CSSProperties>`
  left: ${350 * Screen.widthRatio}px;
  position: absolute;
  top: ${66 * Screen.widthRatio}px;
`;

export default withAnimation(SearchContainer);
